import { render, staticRenderFns } from "./queryForm.vue?vue&type=template&id=2fab2c2b&scoped=true"
import script from "./queryForm.vue?vue&type=script&lang=js"
export * from "./queryForm.vue?vue&type=script&lang=js"
import style0 from "./queryForm.vue?vue&type=style&index=0&id=2fab2c2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab2c2b",
  null
  
)

export default component.exports